import _ExamLabel from "./ExamLabel";
import _MenuLateral from "./MenuLateral";
import _TitleHeader from "./TitleHeader";
import _Searcher from "./Searcher";
import _TableAntd from "./TableAntd";
import _InputAntd from "./InputAntd";
import _NivoPie from "./NivoPie";
import _Responder from "./Responder";
import _HeaderIngresante from "./HeaderIngresante";
import _HeaderSupervisor from "./HeaderSupervisor";
import _UserCard from "./UserCard";
import _ListDesciption from "./ListDesciption";
import _ButtonDownload from "./ButtonDownload";
import _CardReport from "./CardReport";
import _ButtonHelp from "./ButtonHelp";
import _CredencialButton from "./CredencialButton";
import _CredencialButtonV2 from "./CredencialButtonV2";

export const ExamLabel = _ExamLabel;
export const MenuLateral = _MenuLateral;
export const TitleHeader = _TitleHeader;
export const Searcher = _Searcher;
export const TableAntd = _TableAntd;
export const InputAntd = _InputAntd;
export const NivoPie = _NivoPie;
export const Responder = _Responder;
export const HeaderIngresante = _HeaderIngresante;
export const HeaderSupervisor = _HeaderSupervisor;
export const UserCard = _UserCard;
export const ListDesciption = _ListDesciption;
export const ButtonDownload = _ButtonDownload;
export const CardReport = _CardReport;
export const ButtonHelp = _ButtonHelp;
export const CredencialButton = _CredencialButton;
export const CredencialButtonV2 = _CredencialButtonV2;
